"use strict";

const DefaultColumnComponent = require('../default/DefaultColumnComponent');

class EmptyColumnComponent extends DefaultColumnComponent {

    constructor() {
        super('');
    }

    setValue(){
        return this;
    }
    getValue(){
        return this._value;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = EmptyColumnComponent;
